"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _excluded = ["value", "className", "countryCode", "displayAsText"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var numbersMatch = {
  canada: function canada(number) {
    return number.match(/(\d{3})(\d{3})(\d{4})$/);
  },
  franceWithCode: function franceWithCode(number) {
    return number.match(/(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/);
  },
  franceWithoutCode: function franceWithoutCode(number) {
    return number.match(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/);
  }
};

function outputFormat(number) {
  var str = String(number); // remove all unnecessary caracters and return only the numbers
  // eslint-disable-next-line no-useless-escape

  var numbers = str.replace(/[^\d\+]/g, '');
  var codeOrPrefix = numbers.match(/^(\+1|001|\+33|0033)/);
  var intlCode = codeOrPrefix && codeOrPrefix[1] ? codeOrPrefix[1] : undefined;

  if (numbers && numbers.length >= 10) {
    if (codeOrPrefix) {
      if (codeOrPrefix[1] === '+1' || codeOrPrefix[1] === '001') {
        var phoneMatch = numbersMatch.canada(numbers);
        return {
          number: "(" + phoneMatch[1] + ") " + phoneMatch[2] + "-" + phoneMatch[3],
          countryCode: intlCode
        };
      }

      if (codeOrPrefix[1] === '+33' || codeOrPrefix[1] === '0033') {
        var _phoneMatch = numbersMatch.franceWithCode(numbers);

        return {
          number: "0" + _phoneMatch[1] + " " + _phoneMatch[2] + "-" + _phoneMatch[3] + "-" + _phoneMatch[4] + "-" + _phoneMatch[5],
          countryCode: intlCode
        };
      }
    } else if (numbers[0] === '0') {
      var _phoneMatch2 = numbersMatch.franceWithoutCode(numbers);

      return {
        number: _phoneMatch2[1] + " " + _phoneMatch2[2] + " " + _phoneMatch2[3] + " " + _phoneMatch2[4] + " " + _phoneMatch2[5],
        countryCode: intlCode
      };
    } else {
      var _phoneMatch3 = numbersMatch.canada(numbers);

      return {
        number: "(" + _phoneMatch3[1] + ") " + _phoneMatch3[2] + "-" + _phoneMatch3[3],
        countryCode: intlCode
      };
    }
  } else {
    return undefined;
  }
}

var PhoneOutput = function PhoneOutput(props) {
  var value = props.value,
      className = props.className,
      countryCode = props.countryCode,
      displayAsText = props.displayAsText,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var _React$useState = _react.default.useState({}),
      output = _React$useState[0],
      setOutput = _React$useState[1];

  _react.default.useEffect(function () {
    if (value) {
      setOutput(outputFormat(value));
    } else {
      setOutput();
    }
  }, [value]);

  var classes = (0, _clsx.default)('uk-phone-output', className);

  if (displayAsText || !value) {
    return /*#__PURE__*/_react.default.createElement("span", _extends({
      className: classes
    }, attributes), output != null && output.number ? output.countryCode ? output.countryCode + " " + output.number : countryCode ? countryCode + " " + output.number : "" + output.number : /*#__PURE__*/_react.default.createElement("span", null, "No phone number"));
  }

  return output ? /*#__PURE__*/_react.default.createElement("a", _extends({
    className: classes,
    href: "tel:" + (output != null && output.countryCode ? output == null ? void 0 : output.countryCode : '') + (output == null ? void 0 : output.number)
  }, attributes), output.countryCode ? output.countryCode + " " + output.number : countryCode ? countryCode + " " + output.number : "" + output.number) : /*#__PURE__*/_react.default.createElement("span", null, "No phone number");
};

PhoneOutput.propTypes = {
  /**
   * Take any phone numbers
   */
  value: _propTypes.default.any.isRequired,

  /**
   * Display country code
   */
  countryCode: _propTypes.default.oneOf(['', '+1', '+33']),

  /**
   * Display country code
   */
  displayAsText: _propTypes.default.bool
};
PhoneOutput.defaultProps = {
  value: '000 123 4567',
  countryCode: '+1',
  displayAsText: false
};
var _default = PhoneOutput;
exports.default = _default;